/* TEN BUT — Relacionados como saída lateral (EPIC-19 / Story 19.10) ────────────────────────
   ~40% do tráfego entra direto numa PDP. Quando o sapato daquela página não tem o número da
   cliente, o bloco de relacionados é a ÚNICA porta para o resto do catálogo. Este ficheiro
   não constrói o bloco (a section `product-recommendations` já existe e já mostra 4 cards):
   ele ALIMENTA melhor — filtra o conjunto de 10 candidatos que o servidor mandou para deixar
   só quem realmente tem o número, ordena e promove os de reserva que estão no <template>.
   Desde 2026-10-01, com número escolhido, soma a esses 10 o catálogo disponível (segundo
   pedido à mesma section, ver loadCatalog) e ordena tipo → estilo → preço; teto de 6 cards.

   Por que a decisão é no cliente: `Liquid não lê query param`. A Section Rendering API entrega
   a section renderizada, mas o servidor não tem como saber qual número a cliente tentou. As
   alternativas seriam montar cards em JavaScript a partir de JSON — o que refaria um
   renderizador de card que já existe em DUAS versões no tema e furaria a regra de uma imagem
   por card da 19.5 — ou mandar gente a mais com o dado junto e decidir aqui. É esta segunda.

   Carregado por theme.liquid (defer), ao lado de ten-but.js, e NUNCA de dentro da section: a
   section é re-executada a cada morphSection e um <script> lá dentro correria de novo.
*/
(function () {
  if (window.__tbRelatedInit) return;
  window.__tbRelatedInit = true;

  var KEY = 'tb_size_intent';

  /* Ajuste de 2026-10-01: com tamanho escolhido a grelha mostra no MÁXIMO seis cards, ordem do
     dono. Sem tamanho continua valendo o `max_products` do admin (comportamento de antes). */
  var SIZE_MAX = 6;

  /* AC-B1: quando dois sinais caem no MESMO instante, o clique num número esgotado é o mais
     forte — é a evidência literal de "este não serviu". Depois vem o tamanho escolhido na PDP
     e, por último, o número marcado no filtro do catálogo. */
  var RANK = { catalog: 1, selected: 2, sold_out: 3 };

  /* Espelho em memória. `sessionStorage` levanta exceção em aba anónima e com armazenamento
     bloqueado; AC-B2 manda degradar para "só o que aconteceu nesta página", não quebrar. */
  var memIntent = null;

  function readIntent() {
    try {
      var raw = sessionStorage.getItem(KEY);
      if (raw) {
        var parsed = JSON.parse(raw);
        if (parsed && parsed.size) return parsed;
      }
    } catch (e) {}
    return memIntent;
  }

  function writeIntent(size, reason) {
    if (!size) return;
    var ts = Date.now();
    var cur = readIntent();
    if (cur && cur.ts === ts && (RANK[cur.reason] || 0) > (RANK[reason] || 0)) return;
    memIntent = { size: String(size), reason: reason, ts: ts };
    try { sessionStorage.setItem(KEY, JSON.stringify(memIntent)); } catch (e) {}
    applyAll();
  }

  /* Story 19.1 (AC-B4): o número esgotado usa `aria-disabled`, não `disabled` — senão o clique
     não existiria e `sold_out_size_clicked` seria impossível de medir. O predicado global vive
     DENTRO de ten-but-product-main.liquid, logo só existe quando a PDP renderizou; o fallback
     cobre a ordem de carga, igual ao que ten-but-pdp-sticky-atc.js já faz. */
  function sizeUnavailable(btn) {
    if (typeof window.tbSizeUnavailable === 'function') return window.tbSizeUnavailable(btn);
    return !btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true'
      || btn.classList.contains('sold-out');
  }

  /* ── Sinal de tamanho: ouvintes PRÓPRIOS e delegados ──────────────────────────────────────
     Delegados em `document`, fase de captura, para sair antes de quem pare a propagação e para
     sobreviver ao morph. ⛔ ten-but-product-main.liquid NÃO é tocado (a 19.5 está InProgress
     nesse ficheiro): esta story não edita o handler de lá, escuta o mesmo clique. */
  document.addEventListener('click', function (e) {
    try {
      var btn = e.target && e.target.closest && e.target.closest('.tbp__size-btn');
      if (!btn) return;
      var val = btn.getAttribute('data-value');
      if (!val) return;
      writeIntent(val, sizeUnavailable(btn) ? 'sold_out' : 'selected');
    } catch (err) {}
  }, true);

  /* 🔴 A RECOMENDAÇÃO PREPARA O CARD, NÃO MANDA NELE (defeito de 2026-09-16, reportado pelo
     dono no mesmo dia em que a troca de cor entrou).

     A primeira versão reaplicava a cor "certa" a cada `apply()`. Como `applyColor()` mexe no
     DOM e o nosso MutationObserver escuta esse mesmo DOM, tocar no swatch amarelo disparava
     um `apply()` que empurrava a cor de volta: a foto piscava e voltava, e o card ficava
     impossível de navegar. Escolher o 36 passava a PROIBIR ver o amarelo.

     Isso inverte o trabalho do bloco. Ele existe para que ela não caia num beco sem saída —
     não para decidir por ela o que pode olhar. Quem toca num swatch quer ver aquela cor,
     tenha ela o número ou não, e a partir daí aquele card é dela.

     O lock é POR TAMANHO: se ela trocar de número na PDP, o pedido é novo e explícito, a
     lista é refiltrada e o card volta a aceitar a sugestão. Fase de CAPTURA porque o handler
     do swatch (ten-but-swipe.js) chama `stopPropagation()` na fase de bolha — na bolha este
     ouvinte nunca correria. E é o clique REAL que trava: `applyColors()` chama
     `__tbApplyColor()` direto, sem despachar evento, então a nossa própria escrita não se
     autotrava. */
  document.addEventListener('click', function (e) {
    try {
      var btn = e.target && e.target.closest && e.target.closest('.tb-swatch-btn');
      if (!btn) return;
      var item = btn.closest('.resource-list__item');
      if (!item) return;
      var cur = readIntent();
      item.__tbColorLockedFor = cur && cur.size ? String(cur.size) : '';
      /* O pedido pendente tem de morrer aqui: `initCardSwatches()` consome
         `data-tb-want-color` no fim do setup dele, com 80 ms de atraso, e aplicaria a nossa
         cor por cima da que ela acabou de escolher. */
      var host = btn.closest('[data-tb-want-color]');
      if (host) host.removeAttribute('data-tb-want-color');
    } catch (err) {}
  }, true);

  /* Catálogo: marcar um número no filtro. Mesmo input que a 19.3 usa. */
  document.addEventListener('change', function (e) {
    try {
      var input = e.target;
      if (!input || input.name !== 'filter.v.option.rozmiar' || !input.checked) return;
      writeIntent(input.value, 'catalog');
    } catch (err) {}
  }, true);

  /* ── Leitura do dataset que o servidor mandou ─────────────────────────────────────────── */

  function sizesOf(item) {
    var raw = item.getAttribute('data-tb-sizes') || '';
    if (!raw) return [];
    var parts = raw.split(',');
    var out = [];
    for (var i = 0; i < parts.length; i++) {
      var v = parts[i].trim();
      if (v) out.push(v);
    }
    return out;
  }

  /* Mapa `Cor:36,37|Cor2:38` emitido por `tb-product-sizes` em modo by_color, na ORDEM
     CADASTRADA das cores. Vazio (→ null) para produto sem eixo de cor: aí `data-tb-sizes` já
     descreve o card inteiro e a regra antiga vale sem ressalva. */
  function colorMapOf(item) {
    var raw = item.getAttribute('data-tb-sizes-by-color') || '';
    if (!raw) return null;
    var entries = raw.split('|');
    var out = [];
    for (var i = 0; i < entries.length; i++) {
      var cut = entries[i].indexOf(':');
      if (cut < 1) continue;
      var color = entries[i].slice(0, cut).trim();
      var sizes = entries[i].slice(cut + 1).split(',');
      var clean = [];
      for (var j = 0; j < sizes.length; j++) {
        var v = sizes[j].trim();
        if (v) clean.push(v);
      }
      if (color && clean.length) out.push({ color: color, sizes: clean });
    }
    return out.length ? out : null;
  }

  /* A cor que o card deve mostrar para servir `size`: a PRIMEIRA na ordem cadastrada que
     tenha o número. É a mesma régua da âncora da 19.4 (`tb-card-anchor`: primeira cor com
     estoque, na ordem cadastrada) com o tamanho acrescentado ao teste — uma regra só no tema,
     não duas. Devolve '' quando nenhuma cor serve: aí o produto inteiro é descartado. */
  function colorFor(map, size) {
    for (var i = 0; i < map.length; i++) {
      if (map[i].sizes.indexOf(size) !== -1) return map[i].color;
    }
    return '';
  }

  /* Trocar a cor do card depende da fileira de swatches, que só existe com
     `settings.enable_color_swatches` ligada. Desligada, não há como reapontar o card — e aí
     a única saída honesta é a conservadora: o produto só entra se o número existir em TODAS
     as cores, porque qualquer uma que o servidor pinte serve. Sem esta guarda, desligar um
     toggle de tema faria o bloco voltar a prometer números que a foto não tem, em silêncio. */
  function everyColorHas(map, size) {
    for (var i = 0; i < map.length; i++) {
      if (map[i].sizes.indexOf(size) === -1) return false;
    }
    return true;
  }

  function numAttr(el, name) {
    var raw = el.getAttribute(name);
    if (raw === null || raw === '') return null;
    var n = parseFloat(raw);
    return isNaN(n) ? null : n;
  }

  function gridItems(el) {
    var out = [];
    var kids = el.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].classList && kids[i].classList.contains('resource-list__item')) out.push(kids[i]);
    }
    return out;
  }

  /* Os itens que o SERVIDOR pôs na grelha. Um card vindo do catálogo e inserido por nós não é
     "render novo" nem faz parte do conjunto da Shopify: se contasse, a fotografia se refaria
     com ele dentro e, ao limpar o tamanho, o bloco ficaria com cards do catálogo em vez de
     voltar ao de hoje. */
  function serverGridItems(el) {
    var all = gridItems(el);
    var out = [];
    for (var i = 0; i < all.length; i++) if (!all[i].__tbFromCatalog) out.push(all[i]);
    return out;
  }

  function idOf(item) {
    return item.getAttribute('data-tb-product-id') || '';
  }

  function traitsOf(raw) {
    var out = [];
    var parts = (raw || '').split('|');
    for (var i = 0; i < parts.length; i++) {
      var v = parts[i].trim();
      if (v) out.push(v);
    }
    return out;
  }

  /* Quantos traços de estilo (metacampos de categoria + tags, ver `tb-product-traits`) o
     candidato partilha com o produto da página. É o que põe o botki de flores da mesma coleção
     à frente do kalosz, que é `Boots` igual mas não se parece em nada. */
  function traitScore(selfTraits, item) {
    if (!selfTraits.length) return 0;
    var mine = traitsOf(item.getAttribute('data-tb-traits'));
    var n = 0;
    for (var i = 0; i < mine.length; i++) if (selfTraits.indexOf(mine[i]) !== -1) n++;
    return n;
  }

  /* ── Candidatos do catálogo (ajuste de 2026-10-01) ─────────────────────────────────────
     Os 10 da Shopify são poucos e enviesados para produto com histórico: na PDP do Noira
     Bloom com o 39 vinham 3 botas, e Leśny Szlak / Nocny Ogród — no 39, em estoque — não
     tinham como aparecer. Com tamanho escolhido pedimos a MESMA section com
     `intent=complementary`; a section reconhece o pedido e devolve o catálogo disponível num
     <template data-tb-related-catalog> (ver product-recommendations.liquid). Mesmo card, mesmo
     dataset, mesmas configurações do admin.

     Um pedido por página e por bloco, só quando há tamanho — sem tamanho nada muda. Falhou?
     Fica o conjunto da Shopify, que é o comportamento de antes; nunca erro na tela. */
  function catalogUrl(root) {
    var base = root.getAttribute('data-url');
    var pid = root.getAttribute('data-product-id');
    var sid = root.getAttribute('data-section-id');
    if (!base || !pid || !sid) return '';
    return base + (base.indexOf('?') === -1 ? '?' : '&')
      + 'product_id=' + encodeURIComponent(pid)
      + '&section_id=' + encodeURIComponent(sid)
      + '&intent=complementary';
  }

  function loadCatalog(root) {
    if (root.__tbCatalogState) return;
    var url = catalogUrl(root);
    if (!url || typeof fetch !== 'function' || typeof DOMParser !== 'function') {
      root.__tbCatalogState = 'failed';
      return;
    }
    root.__tbCatalogState = 'loading';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('catalog ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var tpl = doc.querySelector('template[data-tb-related-catalog]');
        var out = [];
        if (tpl && tpl.content) {
          var nodes = tpl.content.querySelectorAll('.resource-list__item');
          for (var i = 0; i < nodes.length; i++) {
            var n = document.importNode(nodes[i], true);
            n.__tbFromCatalog = true;
            out.push(n);
          }
        }
        root.__tbCatalog = out;
        root.__tbCatalogState = 'ready';
        apply(root);
      })
      .catch(function () {
        root.__tbCatalogState = 'failed';
      });
  }

  /* Conjunto da Shopify primeiro (a ordem dela continua sendo o desempate final), depois os do
     catálogo que ainda não estão nele. Dedupe por id de produto. */
  function withCatalog(base, catalog) {
    if (!catalog || !catalog.length) return base;
    var seen = {};
    for (var i = 0; i < base.length; i++) {
      var id = idOf(base[i]);
      if (id) seen[id] = true;
    }
    var out = base.slice();
    for (var j = 0; j < catalog.length; j++) {
      var cid = idOf(catalog[j]);
      if (cid && seen[cid]) continue;
      if (cid) seen[cid] = true;
      out.push(catalog[j]);
    }
    return out;
  }

  /* Fotografia do conjunto na ORDEM DO SERVIDOR: os que já estão na grelha, seguidos dos de
     reserva clonados do <template>. Guardada no próprio elemento da grelha — a cada morph a
     grelha é outra e a fotografia se refaz sozinha. Clonar (em vez de usar `template.content`
     direto) mantém o <template> intacto para o caso de o tamanho mudar de novo. */
  function snapshot(grid, pool) {
    var cached = grid.__tbRelatedItems;
    if (cached) {
      /* `morphSection` faz morph, não replace: pode REAPROVEITAR os mesmos nós da grelha e só
         trocar o conteúdo deles. Então não dá para confiar na identidade da grelha para saber
         que o servidor mandou gente nova. A régua é: se apareceu na grelha um item que não
         está na fotografia, houve render novo e a fotografia se refaz. */
      var cur = serverGridItems(grid);
      var stale = false;
      for (var c = 0; c < cur.length; c++) {
        if (cached.indexOf(cur[c]) === -1) { stale = true; break; }
      }
      if (!stale) return cached;
    }
    var items = serverGridItems(grid);
    grid.__tbRelatedMax = items.length;
    if (pool && pool.content) {
      var frag = pool.content.cloneNode(true);
      var extra = frag.querySelectorAll('.resource-list__item');
      for (var i = 0; i < extra.length; i++) items.push(extra[i]);
    }
    grid.__tbRelatedItems = items;
    return items;
  }

  /* ── Filtro duro + ordem ──────────────────────────────────────────────────────────────── */

  /* `self` = { id, type, price, traits } do produto da página. */
  function pick(items, size, self) {
    var kept = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      /* A própria PDP nunca é sugestão de si mesma. A Shopify já não a manda; o catálogo
         também a tira no servidor — esta é a guarda de quem chama. */
      if (self.id && idOf(it) === self.id) continue;
      /* AC-C2: esgotado não entra. Na prática já é consequência do filtro duro — produto
         esgotado não tem tamanho comprável nenhum — mas a guarda é explícita. */
      if (it.getAttribute('data-tb-available') === 'false') continue;
      /* AC-C1: filtro DURO. Sem o número, não aparece. Não há "quase serve" — é exatamente o
         beco sem saída que a 19.3 fechou no catálogo.

         ⚠️ Defeito de 2026-09-16: a régua tem de ser a COR QUE O CARD MOSTRA, não o produto.
         `data-tb-sizes` soma as variantes todas; em 12 dos 41 produtos da loja as cores têm
         grades diferentes, e o Articer entrava na lista do 36 exibindo a cor Orange, que só
         tem 37 e 38. Com o mapa por cor o produto continua a entrar — mudamos a COR do card
         para a que serve, em vez de o descartar. Sem mapa (produto sem cor), regra antiga. */
      var map = colorMapOf(it);
      var want = '';
      if (map) {
        want = colorFor(map, size);
        if (!want) continue;
        if (!it.querySelector('.tb-swatch-btn')) {
          if (!everyColorHas(map, size)) continue;
          want = '';
        }
      } else if (sizesOf(it).indexOf(size) === -1) {
        continue;
      }
      it.__tbWantColor = want;
      var type = (it.getAttribute('data-tb-type') || '').toLowerCase();
      var price = numAttr(it, 'data-tb-price');
      kept.push({
        el: it,
        order: i,
        sameType: (self.type && type === self.type) ? 0 : 1,
        style: traitScore(self.traits, it),
        priceGap: (self.price === null || price === null) ? Infinity : Math.abs(price - self.price),
        /* AC-C2.3: sem agregado NÃO é nota 0 — vai depois de quem tem nota, não no fim de uma
           escala numérica onde competiria de igual para igual com quem tem 1 estrela. */
        rating: numAttr(it, 'data-tb-rating')
      });
    }
    kept.sort(function (a, b) {
      if (a.sameType !== b.sameType) return a.sameType - b.sameType;
      /* Ajuste de 2026-10-01: dentro do mesmo tipo, o PARECIDO vem antes do preço. É o que
         separa botki de kalosz — os dois são `Boots`. Preço é o critério seguinte. */
      if (a.style !== b.style) return b.style - a.style;
      if (a.priceGap !== b.priceGap) return a.priceGap - b.priceGap;
      var ar = a.rating === null ? -1 : a.rating;
      var br = b.rating === null ? -1 : b.rating;
      if (ar !== br) return br - ar;
      /* AC-C2.4: empate total ⇒ ordem em que o servidor mandou. A recomendação da Shopify é o
         desempate final, não é descartada. */
      return a.order - b.order;
    });
    var out = [];
    for (var j = 0; j < kept.length; j++) out.push(kept[j].el);
    return out;
  }

  /* ── Pintura ──────────────────────────────────────────────────────────────────────────── */

  /* AC-D1: descartado SAI do DOM, não fica escondido por CSS. É isso que mantém o `index` do
     `select_item` sendo a posição real do card na tela. */
  function render(grid, list) {
    var focused = document.activeElement;
    var focusWasInside = focused && focused !== document.body && grid.contains(focused);
    var current = gridItems(grid);
    for (var i = 0; i < current.length; i++) {
      if (list.indexOf(current[i]) === -1) grid.removeChild(current[i]);
    }
    for (var j = 0; j < list.length; j++) {
      if (grid.children[j] !== list[j]) grid.insertBefore(list[j], grid.children[j] || null);
    }
    /* AC-C9: sem foco órfão. Só mexe no foco se ele estava dentro da grelha e o elemento saiu
       com o card descartado — nunca rouba foco de quem está noutro ponto da página. */
    if (focusWasInside && !document.contains(focused)) {
      var first = grid.querySelector('a[href], button');
      /* tb-focus-scroll-ok: só corre depois de a pessoa mexer no tamanho, com o CSS já
         aplicado, e o alvo está na grelha que ela estava a usar. */
      if (first) first.focus();
    }
  }

  /* ── Cor do card ──────────────────────────────────────────────────────────────────────
     Não reimplementamos a troca: `applyColor()` de ten-but-swipe.js (Story 8.2, endurecida
     pela 19.4) já troca foto, TODOS os `<a>` que apontam para /products/, o preço e o estado
     do swatch numa passagem só, nas três estruturas de card do tema. Aqui só se decide QUAL
     cor e se aciona a de lá — REUSE > ADAPT > CREATE.

     Quando ela ainda não está ligada (o observer de re-init de lá corre com 80 ms de debounce,
     este ficheiro corre no microtask do MutationObserver), deixamos o pedido escrito em
     `data-tb-want-color` e `initCardSwatches()` consome-o no fim do seu próprio setup. Assim
     não há corrida: quem chegar por último resolve. */
  function swatchHost(item) {
    var btn = item.querySelector('.tb-swatch-btn');
    if (!btn) return null;
    var el = btn.parentElement;
    while (el && el !== item.parentElement) {
      if (typeof el.__tbApplyColor === 'function') return el;
      el = el.parentElement;
    }
    /* Mesma lista de `initCardSwatches()`, em ordem de documento: o host é o ancestral que
       aquele ficheiro vai processar, e é nele que o atributo tem de ficar. */
    return item.querySelector('product-card, .product-card, .tb-product-card') || item;
  }

  function applyColors(grid, size) {
    var items = gridItems(grid);
    for (var i = 0; i < items.length; i++) {
      /* Card que ela já mexeu, com este mesmo número em vigor: não se toca. É a linha que
         devolve a navegação — sem ela, escolher um tamanho tranca o card numa cor só. */
      if (items[i].__tbColorLockedFor === size) continue;
      var host = swatchHost(items[i]);
      if (!host) continue;
      var btns = host.querySelectorAll('.tb-swatch-btn');
      if (!btns.length) continue;

      var target = null;
      var current = null;
      var server = null;
      for (var j = 0; j < btns.length; j++) {
        if (btns[j].classList.contains('is-selected')) current = btns[j];
        if (btns[j].getAttribute('data-tb-server-selected') === 'true') server = btns[j];
      }
      /* Sem tamanho escolhido (ou depois de a cliente limpar o número) o card volta à cor que
         o SERVIDOR pintou — senão ficaria preso na cor do último filtro. */
      var want = items[i].__tbWantColor || '';
      if (!want) target = server;
      else {
        for (var k = 0; k < btns.length; k++) {
          if (btns[k].getAttribute('aria-label') === want) { target = btns[k]; break; }
        }
      }
      if (!target || target === current) continue;

      if (typeof host.__tbApplyColor === 'function') host.__tbApplyColor(target);
      else if (want && host.getAttribute('data-tb-want-color') !== want) {
        /* Escrita condicionada a haver diferença real — a mesma disciplina de paintHint():
           reescrever um atributo com o mesmo valor acorda o MutationObserver e o laço nunca
           fecharia. */
        host.setAttribute('data-tb-want-color', want);
      }
    }
  }

  function paintHint(root, size, reason) {
    var hint = root.querySelector('[data-tb-related-hint]');
    if (!hint) return;
    var tpl = size
      ? (reason === 'sold_out'
          ? hint.getAttribute('data-tb-hint-sold-out')
          : hint.getAttribute('data-tb-hint-neutral'))
      : '';
    var text = tpl ? tpl.split('__SIZE__').join(size) : '';
    /* `aria-live="polite"`: só escrever quando muda, senão o leitor de ecrã reanuncia a mesma
       frase a cada re-filtragem. */
    if (hint.textContent !== text) hint.textContent = text;
    /* AC-C6: visibilidade por CLASSE com `display:`. O atributo `hidden` perde para `display:`
       e já deixou botões da Furgonetka visíveis no carrinho, no live.

       ⚠️ `classList.add/remove` REESCREVE o atributo `class` mesmo quando o token já está (ou
       já não está) lá, e o MutationObserver regista isso como mudança de atributo — sem o
       `contains` abaixo, cada apply() acordava o seguinte e o laço nunca fechava, travando a
       aba. Toda escrita neste ficheiro é condicionada a haver diferença real. */
    var on = hint.classList.contains('tb-related-hint--on');
    if (text && !on) hint.classList.add('tb-related-hint--on');
    else if (!text && on) hint.classList.remove('tb-related-hint--on');
  }

  /* AC-D2: `data-tb-size-filter` só pode ser escrito DEPOIS de a hidratação terminar. O
     MutationObserver da própria section dispara `#loadRecommendations()` a QUALQUER mudança de
     atributo no container; escrever antes de `data-recommendations-performed` virar `true`
     forçaria o fetch na hora e mataria a hidratação preguiçosa dos 400px. E tem de ser
     reescrito a cada morph, porque o HTML do servidor não traz o atributo. */
  function setFilterAttr(root, size) {
    if (size) {
      if (root.getAttribute('data-tb-size-filter') !== size) root.setAttribute('data-tb-size-filter', size);
    } else if (root.hasAttribute('data-tb-size-filter')) {
      root.removeAttribute('data-tb-size-filter');
    }
  }

  var busy = false;

  function apply(root) {
    if (busy) return;
    /* AC-A4: desiste EM SILÊNCIO fora do modo grelha — carrossel, onboarding e esqueleto
       continuam exatamente como hoje, sem erro no console. */
    var grid = root.querySelector('.resource-list--grid');
    if (!grid) return;
    if (root.getAttribute('data-recommendations-performed') !== 'true') return;

    busy = true;
    try {
      var items = snapshot(grid, root.querySelector('template[data-tb-related-pool]'));
      if (!items.length) return;

      var max = parseInt(root.getAttribute('data-tb-related-max') || '', 10);
      if (!max || isNaN(max)) max = grid.__tbRelatedMax || items.length;

      var intent = readIntent();
      var size = intent && intent.size ? String(intent.size) : '';
      var chosen = null;
      if (size) {
        /* Com número escolhido, o catálogo entra como candidato. Enquanto ele não chega, filtra
           o que a Shopify mandou; quando chega, `loadCatalog` chama apply() de novo. */
        loadCatalog(root);
        var matches = pick(withCatalog(items, root.__tbCatalog), size, {
          id: root.getAttribute('data-tb-self-id') || '',
          type: (root.getAttribute('data-tb-self-type') || '').toLowerCase(),
          price: numAttr(root, 'data-tb-self-price'),
          traits: traitsOf(root.getAttribute('data-tb-self-traits'))
        });
        /* AC-C3: até SIZE_MAX, podendo ser MENOS. ⛔ Proibido completar a grelha com produto
           que não tem o número. */
        if (matches.length) chosen = matches.slice(0, SIZE_MAX);
      }
      if (!chosen) {
        /* AC-B3 (nenhum tamanho conhecido) e AC-C4 (zero casamentos): volta ao bloco de hoje,
           com o cabeçalho neutro do admin. O bloco NÃO some — a saída lateral continua sendo a
           única porta para o catálogo — e não promete tamanho nenhum. */
        chosen = items.slice(0, max);
        size = '';
        /* Sem filtro não há cor pedida: limpar aqui é o que faz `applyColors` devolver cada
           card à cor do servidor em vez de o deixar na cor do tamanho anterior. */
        for (var c = 0; c < chosen.length; c++) chosen[c].__tbWantColor = '';
      }

      render(grid, chosen);
      applyColors(grid, size);
      paintHint(root, size, intent && intent.reason);
      setFilterAttr(root, size);
    } finally {
      busy = false;
    }
  }

  function watch(root) {
    if (root.__tbRelatedWatched) return;
    root.__tbRelatedWatched = true;
    /* A re-filtragem roda no callback do MutationObserver, que é microtask: acontece DEPOIS do
       morph e ANTES do próximo layout. É isso que faz o descarte custar zero pedido de imagem
       (AC-C8) — o card sai do DOM antes de o browser avaliar o lazy-load. */
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        /* Ignorar a escrita do PRÓPRIO atributo de filtro: sem isto, cada apply() acordaria o
           seguinte. As outras mudanças que este ficheiro faz (texto da dica, classe, cards)
           convergem sozinhas — o segundo apply não encontra nada para mudar. */
        if (mutations[i].type === 'attributes' && mutations[i].attributeName === 'data-tb-size-filter') continue;
        apply(root);
        return;
      }
    }).observe(root, {
      attributes: true,
      childList: true,
      subtree: true
    });
  }

  function applyAll() {
    var roots = document.querySelectorAll('product-recommendations');
    for (var i = 0; i < roots.length; i++) {
      watch(roots[i]);
      apply(roots[i]);
    }
  }

  /* AC-C7: funciona nas duas ordens. Tamanho escolhido ANTES da hidratação preguiçosa — o
     sinal já está guardado e o observer re-filtra assim que a section hidrata. Escolhido
     DEPOIS — `writeIntent` chama `applyAll()` na hora, sem recarregar. */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyAll);
  else applyAll();
})();
